import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { Contact, ContactSearchOptions } from '@atlassian/cssxp-types-contact';
import {
  PartnerAccount,
  PartnerAccountContactSearchParams,
  PartnerAccountSearchOptions,
  PartnerAccountSearchParams,
} from '@atlassian/cssxp-types-customer';
import { Results } from '@atlassian/cssxp-typescommon';

const client = createAxiosClient({ baseURL: '/api/1/partner-accounts' }, ServiceProxyMap.ANS);

export async function fetchPartnerAccount(partnerAccountId: string): Promise<PartnerAccount> {
  const result = await client.get(`/${partnerAccountId}`);

  return result.data;
}

export async function searchPartnerAccounts(
  searchParams: PartnerAccountSearchParams & PartnerAccountSearchOptions
): Promise<Results<PartnerAccount>> {
  const result = await client.get('/', { params: searchParams });

  return result.data;
}

export async function searchPartnerAccountContacts(
  searchParams: PartnerAccountContactSearchParams & ContactSearchOptions
): Promise<Results<Contact>> {
  const { partnerAccountId, ...params } = searchParams;

  const result = await client.get(`/${partnerAccountId}/contacts`, {
    params,
  });

  return result.data;
}
